import * as React from "react"
import { graphql } from "gatsby"

import Page from "../components/Page"
import Recweek from "../screens/Recweek"

import SEO from "../components/SEO"

const RecWeek: React.FC<{}> = function (props) {
  return (
    <Page contactUsVisibility="hide">
      <SEO title="Recweek" />
      <Recweek data={props.data.allContentfulRecweek.edges[0].node} />
    </Page>
  )
}

export default RecWeek
export const query = graphql`
  {
    allContentfulRecweek {
      edges {
        node {
          description {
            description
          }
          join {
            join
          }
          bagwisanStaff {
            title
            description {
              description
            }
            submissionDetails {
              submissionDetails
            }
            requirements
          }
          artStaff {
            title
            description {
              description
            }
            submissionDetails {
              submissionDetails
            }
            requirements
          }
          heightsOnlineStaff {
            title
            description {
              description
            }
            submissionDetails {
              submissionDetails
            }
            requirements
          }
          englishStaff {
            title
            description {
              description
            }
            submissionDetails {
              submissionDetails
            }
            requirements
          }
          designStaff {
            title
            description {
              description
            }
            submissionDetails {
              submissionDetails
            }
            requirements
          }
          productionStaff {
            title
            description {
              description
            }
            submissionDetails {
              submissionDetails
            }
            requirements
          }
        }
      }
    }
  }
`